module.exports = __webpack_public_path__ + "static/media/logo.40b9cde2.png";